const ChangePhotoForm = () => {
  return <div>Future Change Photo Form</div>;
};

export { ChangePhotoForm };
